// Thành phần hiển thị nhỏ của giao dịch: chip trạng thái (nhãn + tông từ @cathouse/domain DEAL_STATUS), chip đợt thanh
// toán, mã giao dịch (mono).
import { DEAL_STATUS } from '@/shared/lib';
import { StatusChip, type Tone } from '@/shared/ui';
import { INSTALLMENT_ROW_STATUS_LABEL, type DealStatus, type InstallmentRowStatus } from './model';

export const dealStatusLabel = (s: DealStatus) => DEAL_STATUS[s]?.label ?? s;
export const dealStatusTone = (s: DealStatus): Tone => DEAL_STATUS[s]?.tone ?? '';

/** Chờ duyệt cọc (violet) · Đã cọc (warn) · Đã ký HĐ / Hoàn tất (good) · Bị từ chối / Đã huỷ (bad). */
export function DealStatusChip({ status }: { status: DealStatus }) {
  return <StatusChip tone={dealStatusTone(status)}>{dealStatusLabel(status)}</StatusChip>;
}

const INSTALLMENT_TONE: Record<InstallmentRowStatus, Tone> = { paid: 'good', overdue: 'bad', partial: 'warn', upcoming: 'neutral', cancelled: 'neutral' };
/** Đã thu (good) · Quá hạn (bad) · Thu một phần (warn) · Chưa đến · Đã huỷ (giao dịch đã huỷ / bị từ chối — deal-service trả). */
export function InstallmentStatusChip({ status }: { status: InstallmentRowStatus }) {
  return <StatusChip tone={INSTALLMENT_TONE[status]}>{INSTALLMENT_ROW_STATUS_LABEL[status]}</StatusChip>;
}

export const DealCode = ({ code, className = 'mono small strong' }: { code: string; className?: string }) => <span className={className}>{code}</span>;
